import React, { useState } from "react";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import logo from "../../img/logo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SettingsIcon from "@mui/icons-material/Settings";
import { decryptText } from "../../utility/cryptoUtils";
import NotificationDialog from "./NotificationDialog";
import { Box } from "@mui/material";

const AppNavbar = ({ handleLogout, toggleSidebar,  }) => {
  const [isOldData,setIsOldData]=useState(JSON.parse(localStorage.getItem("importedOldData")))
  const userName =
    localStorage.getItem("user_name") !== "undefined"
      ? localStorage.getItem("user_name")
      : "user";
  const role =
    localStorage.getItem("role") !== "undefined"
      ? localStorage.getItem("role")
      : "user-role";
const handleImportOldData=()=>{
  const toggle =!(JSON.parse(localStorage.getItem("importedOldData")))
  
  console.log(toggle)
  setIsOldData(toggle)
  localStorage.setItem("importedOldData",toggle)
  window.location.reload();
}
  return (
    <Navbar expand="lg" className="p-2 bg-dark">
      <Container
        fluid
        style={{ marginTop: "1.5rem",flexWrap:"nowrap" }}
        className="justify-content-between align-items-center px-0"
      >
        <div className="d-flex align-items-center gap-3">
          <button
            className="btn btn-outline-light toggle-btn d-block d-lg-none"
            onClick={toggleSidebar}
          >
            <i className="bi bi-list"></i>
          </button>
          <h5 className="mx-3 fs-3">Hogist CRM</h5>
        </div>

        <Box sx={{ display: "flex", alignItems: "center", }}>
        
          <NotificationDialog
            userEmail={decryptText(localStorage.getItem("email"))}
          />


          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              id="dropdown-settings"
              style={{
                cursor: "pointer",
                color: "white",
                display: "flex",
                alignItems: "center",
                padding: "6px 12px",
                borderRadius: "20px",
              }}
            >
              <SettingsIcon fontSize="medium" />
              
            </Dropdown.Toggle>

            <Dropdown.Menu
              align="end"
              style={{
                borderRadius: "10px",
                padding: "0.5rem",
                minWidth: "180px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              <Dropdown.Item
                onClick={handleImportOldData}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 12px",
                  fontSize: "0.9rem",
                  borderRadius: "6px",
                }}
                className="dropdown-hover"
              >
                <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
            { !isOldData ?"Import Old Data":"Import New Data"}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              id="dropdown-avatar"
              className="no-caret"
              style={{
                cursor: "pointer",
                color: "white",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 12px",
                borderRadius: "20px",
              }}
            >
              <AccountCircle fontSize="medium" />
              <span
                className="d-none d-sm-block"
                style={{ fontSize: "1.1rem", fontWeight: 500 }}
              >
                {userName}
              </span>
              <ArrowDropDownIcon
                sx={{
                  display: {
                    xs: "none",
                    sm: "block",
                  },
                }}
                fontSize="medium"
              />
            </Dropdown.Toggle>

            <Dropdown.Menu
              align="end"
              style={{
                borderRadius: "10px",
                padding: "0.5rem",
                minWidth: "180px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  padding: "8px 12px",
                  fontWeight: "600",
                  color: "#555",
                  borderBottom: "1px solid #eee",
                  fontSize: "0.9rem",
                }}
              >
                {userName} - {decryptText(role)}
              </div>

              <Dropdown.Item
                onClick={handleLogout}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "5px",
                  gap: "8px",
                  padding: "10px 12px",
                  fontSize: "0.9rem",
                  borderRadius: "6px",
                  color: "red",
                }}
                className="dropdown-hover"
              >
                <i
                  className="bi bi-box-arrow-right"
                  style={{ fontSize: "1rem", color: "red" }}
                ></i>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Box>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
